import React from 'react';

import { differenceInYears, parse, format } from 'date-fns';

import styles from './BasicInfo.module.scss'

export const BasicInfo = ({
    user,
    title="BASIC INFO",
    subtitle="",
    includeName=true,
    includeAge=true,
    includeDOB=false,
    maxWidth="250px",
    border=true,
    hover=false,
    alignment="center"
})=>{

    return(
        <div 
            style={{maxWidth: maxWidth}}
            className={`
                ${styles["basic-info-wrapper"]}
                ${styles[border ? "border" : ""]}
                ${styles[hover ? "hover" : ""]}
        `}>
            {title &&
                <p className={styles["title"]}>{title}</p>
            }
            {subtitle &&
                <p className={styles["subtitle"]}>{subtitle}</p>
            }
            <div className={`
                ${styles["main-body"]}
                ${alignment === "center" ? styles["center"] : ""}
            `}>
                {includeName &&
                    <div>
                        <span className={styles["label"]}>
                            Name: 
                        </span>
                        {user?.first_name} {user?.last_name}
                    </div>
                }
                {includeAge &&
                    <div>
                        <span className={styles["label"]}>
                            Age: 
                        </span>
                        {user?.dob ? differenceInYears(new Date(), new Date(user?.dob)) : "N/A"}
                    </div>
                }
                {includeDOB &&
                    <div>
                        <span className={styles["label"]}>
                            DOB: 
                        </span>
                        {user?.dob ? format(new Date(user?.dob), 'MM/dd/yyyy') : "N/A"}
                    </div>
                }
            </div>
        </div>
    );
};